<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer002">
<p class="noindent centre"><b>Praise for <em class="italic">Aftermath</em> by LeVar Burton</b></p>
<p class="noindent1">“Deftly crafted … adds new depth and perspective to the science fiction genre.” —<em class="italic">The Denver Post</em></p>
<p class="noindent1">“Epic, along the lines of <em class="italic">The Stand</em>; spiritual, along the lines of <em class="italic">The Seven Arrows. </em>I highly recommend this book!” —Whoopi Goldberg</p>
<p class="noindent1">“A thoroughly entertaining debut.” —<em class="italic">The Philadelphia Inquirer</em></p>
<p class="noindent1">“I was deeply moved. In LeVar Burton’s brilliantly realized cautionary tale, heroic men and women embody timeless values that will always make a difference—courage, passion, wisdom, and, most of all, love. I recommend this novel to anyone who cares about the human spirit.” —Anthony Robbins, author of <em class="italic">Awaken the Giant Within</em></p>
<p class="noindent1">“Assured prose, with a well-developed plot … [A] wise, above-average debut.” —<em class="italic">Kirkus Reviews</em></p>
<p class="noindent1">“Thoroughly readable … [LeVar Burton] has mastered the art of keeping readers turning pages.” —<em class="italic">Booklist</em></p>
<p class="noindent1">“An entertaining debut.” —<em class="italic">The Plain Dealer</em></p>
<p class="noindent1">“An amazingly good first novel … builds tension with the best of them … Burton’s characters are believable; his protagonists are likable and his antagonist is one nasty dude.” —<em class="italic">Rocky Mountain News</em></p>
<p class="noindent1">“Evocative … Adeptly told … Burton’s gift as a storyteller enthralls you.” —<em class="italic">South Florida Sun-Sentinel</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise.vue?09779fae